import React from "react";

import Policies from "../../policies/Policies.jsx";

const SectionPolicies = (props) => {
  return <Policies />;
};
export default SectionPolicies;
